import { Book, Dashboard } from '@apis/index'
import Card from '@components/card'
import Column from '@components/column'
import GridCard, { IGridItem } from '@components/gridCard'
import ImageGallery from '@components/image/imgaeGallery'
import Row from '@components/row'
import { StyleBg } from '@components/status/style'
import { StyleColumn } from '@components/styles'
import Typography from '@components/typography'
import { Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { styleCard } from '../auth/style'

const AdminBookView = () => {
  const { id: bookId } = useParams()
  const { data: book } = useSelector((state: any) => state.book)
  const fetchBook = async () => {
    await Book.getBook(bookId).catch(() => {})
  }
  const { data: dashboard } = useSelector((state: any) => state.bookDashboard)

  const fetchDashboard = async () => {
    const params = {
      type: 'book',
    }
    await Dashboard.getAllDashboardCount('bookDashboard', params)
  }
  useEffect(() => {
    if (!book?.id) {
      fetchBook()
    }
    fetchDashboard()
  }, [])
  const items: IGridItem[] = [
    {
      title: 'Total Books Listed',
      value: dashboard?.totalBook || '0',
      Icon: 'book',
      IconBg: 'blueLight',
    },
    {
      title: 'Pending Book Request',
      value: dashboard?.totalPendingBook || '0',
      Icon: 'book',
      IconBg: 'redLight',
    },
    {
      title: 'Total Book Lend',
      value: dashboard?.totalLendBook || '0',
      Icon: 'book',
      IconBg: 'greenLight',
    },
    {
      title: 'Total Book Returned',
      value: dashboard?.totalReturnedBook || '0',
      Icon: 'book',
      IconBg: 'yellowLight',
    },
  ]
  const restImages = book?.additionalImages
    ? book?.additionalImages?.map((item) => {
        return item?.images
      })
    : []

  return (
    <Fragment>
      <StyleColumn>
        <GridCard items={items} />
        <Card customStyle={styleCard} radius={12}>
          <Row justifyContent="space-between" styleRow={{ width: '100%' }}>
            <Column styleColumn={{ width: '25%' }}>
              <ImageGallery images={[book.coverImage, ...restImages]} />
            </Column>
            <Column styleColumn={{ width: '70%' }} rowGap={10}>
              <Column>
                <Typography content={book?.name} size={24} />
                <Typography content={book?.author} size={20} tc="primary" />
              </Column>
              <StyleBg tc="primaryText" bg="cyan100">
                {book?.categoryData?.name}
              </StyleBg>
              <Typography content={'Description'} size={18} />
              <Typography
                content={book?.description}
                size={16}
                tc="grey400"
                styleText={{ textAlign: 'justify' }}
              />
            </Column>
          </Row>
        </Card>
      </StyleColumn>
    </Fragment>
  )
}

export default AdminBookView
